import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../../redux/store';
import { isTestEnvironment } from '../../../../utils/utils';
import { PlayerBubblesContainer } from './playerBubblesContainer';
const PIXI_DATA = isTestEnvironment() ? { type: 'player-bubbles' } : null;
export const AllPlayerBubblesContainer = () => {
    const seatedPlayerSeatIndexes = useAppSelector((state) => state.poker.seatedPlayerSeatIndexes, shallowEqual);
    return (_jsx(Container, { "pixi-data": PIXI_DATA, interactiveChildren: false, children: seatedPlayerSeatIndexes.map((seatIndex) => (_jsx(PlayerBubblesContainer, { seatIndex: seatIndex }, seatIndex))) }));
};
